import { Form, notification, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { CONTRACT_ROUTE_PATH, FINISH_ROUTE_PATH } from '../App'
import { Cover } from '../components'
import { Loading } from '../components/common'
import DetailsForm from '../components/Details/DetailsForm'
import { useUploadProcess } from '../context/UploadProcessProvider'
import { StepsPage } from '../structure'
const { Paragraph } = Typography

const STEP_NUMBER = 2
const DETAILS_TAB_NUMBER = 1

const Details = () => {
  const { t } = useTranslation()
  const { data, setValues, updateSubmission } = useUploadProcess()

  const navigate = useNavigate()
  const params = useParams()
  const id = parseInt(params.id)
  const submission_id = parseInt(params.submission_id)

  const [title, setTitle] = useState(data.title)
  const [loading, setLoading] = useState(true)
  const [form] = Form.useForm()

  useEffect(() => {
    if (!data.draft) {
      redirectTo(FINISH_ROUTE_PATH)
      return
    }
    if (data.contract_option === null) {
      redirectTo(CONTRACT_ROUTE_PATH)
    } else {
      form.setFieldsValue(data)
      setLoading(false)
    }
  }, [])

  const displayError = (message) => {
    notification.warning({
      message: t(message),
      placement: 'bottomLeft',
    })
  }

  const handleTitleChange = (changedFields, allFields) => {
    changedFields.forEach((fieldObj) => {
      if (fieldObj.name[0] === 'title') {
        setTitle(fieldObj.value)
      }
    })
  }

  const prettifyValues = (data) => {
    const result = data
    if (result['categories']) {
      result['categories'] = [
        {
          _id: parseInt(result['categories']),
        },
      ]
    }
    if (result['subject']) {
      result['subjects'] = [
        {
          _id: parseInt(result['subject'].match(/\d+/)),
        },
      ]
      delete result['subject']
    }
    if (result['institutions']) {
      const id = parseInt(result['institutions'].match(/\d+/))
      result['institutions'] = [
        {
          _id: id,
        },
      ]
    }
    if (result['institutions_name']) {
      result['institutions'] = [
        {
          name: result['institutions_name'],
        },
      ]
      delete result['institutions_name']
    }
    if (result['institute']) {
      if (result['institutions']?.[0]) {
        result['institutions'][0]['institute'] = result['institute']
      } else {
        result['institutions'] = [
          {
            institute: result['institute'],
          },
        ]
      }
      delete result['institute']
    }
    return result
  }

  const handleDetailsSave = (values) => {
    const details = prettifyValues(values)
    details.draft = false
    const onSuccess = () => {
      setValues({ title: details.title })
      setValues({ ...details, draft: false })
      redirectTo(FINISH_ROUTE_PATH)
    }
    setSubmissionDetails(details, onSuccess)
  }

  const setSubmissionDetails = async (details, onSuccess) => {
    updateSubmission(submission_id, details, onSuccess, (status) => {
      displayError(status)
    })
  }
  const redirectTo = (path) => {
    navigate(path.replace(':submission_id', submission_id).replace(':id', id))
  }

  return (
    <StepsPage
      step={STEP_NUMBER}
      tab={DETAILS_TAB_NUMBER}
      title={t('Details.AddDetails')}
      className="details-text"
    >
      <Paragraph style={{ marginTop: '-24px' }}>
        {t('Details.DetailsPublication')}
        <br />
        {t('Details.WeFillDetails')}
      </Paragraph>
      {loading ? (
        <Loading />
      ) : (
        <Form
          form={form}
          onFinish={handleDetailsSave}
          onFieldsChange={handleTitleChange}
          layout="vertical"
          className="details-form"
        >
          <DetailsForm>
            <Cover author={data?.author} title={title} />
          </DetailsForm>
        </Form>
      )}
    </StepsPage>
  )
}
export default Details
